module.exports = __webpack_public_path__ + "img/approve-outline.4c4345cd.svg";